import { GridColDef } from '@mui/x-data-grid-pro';

export const conditionalGridColDefs = <T>(
  condition: boolean,
  column: GridColDef<T>,
): GridColDef<T>[] => {
  return condition ? [column] : [];
};
